module.exports = __webpack_public_path__ + "static/img/__8304.a0957ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8304.jpg
// module id = LCS9
// module chunks = 0